import _get from "lodash.get";
var params = new Proxy(new URLSearchParams(window.location.search), {
    get: function (searchParams, prop) { return searchParams.get(prop); },
});
var get = function (key) {
    return _get(params, key, undefined) || undefined;
};
var UtilsParams = {
    get: get,
};
export default UtilsParams;
